export const LOCAL_STATE_STORAGE = "STATE"
